var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shopicon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.083,
    cy: 17.997,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.002,
    cy: 17.997,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.083,31.913C28.448,31.913,32,28.363,32,24h-4c0,2.157-1.757,3.913-3.917,3.913S20.166,26.157,20.166,24h-4 C16.166,28.363,19.718,31.913,24.083,31.913z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.369,19.029C39.205,11.517,32.282,6,24.083,6S8.961,11.517,6.797,19.029C5.282,19.177,4.083,20.448,4.083,22v4 c0,1.65,1.35,3,3,3c1.65,0,3-1.35,3-3v-2.002C10.084,16.279,16.364,10,24.083,10c7.72,0,14,6.28,14,14s-6.28,14-14,14v0h-2.014 c-1.65,0-3,1.35-3,3s1.35,3,3,3h4.014c1.552,0,2.824-1.199,2.971-2.714c5.931-1.709,10.606-6.384,12.315-12.315 c1.515-0.147,2.714-1.419,2.714-2.971v-4C44.083,20.448,42.884,19.176,41.369,19.029z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.0a2dd094f00b043e2553258a37a99796.svg";
export { ForwardRef as ReactComponent };